import { GridInitialStatePro } from "@mui/x-data-grid-pro/models/gridStatePro";
import { DEFAULT_PAGINATION_MODEL } from "src/components/common/dataGrid/utils";
import { DataGridProProps } from "@mui/x-data-grid-pro";

export type DataGridPersistStateProps = Required<Pick<DataGridProProps, "onStateChange" | "initialState">>;

export const dataGridPersistentStateProps = (
	gridId: string,
	initialState: GridInitialStatePro = DEFAULT_INITIAL_STATE,
): DataGridPersistStateProps => {
	return {
		onStateChange: (state: any) => saveDataGridState(gridId, state),
		initialState: getStoredDataGridState(gridId, initialState),
	};
};

const saveDataGridState = (gridId: string, state: any) => {
	if (gridId === undefined) return;
	localStorage.setItem(getStoredStateKey(gridId), JSON.stringify(state));
};

export const getStoredDataGridState = (
	gridId: string | undefined,
	defaultState: GridInitialStatePro = DEFAULT_INITIAL_STATE,
) => {
	if (gridId === undefined) return defaultState;

	const savedState = localStorage.getItem(getStoredStateKey(gridId));
	if (savedState === null) return defaultState;

	return JSON.parse(savedState);
};

const getStoredStateKey = (gridId: string) => {
	return `data-grid-state--${gridId}`;
};

const DEFAULT_INITIAL_STATE = {
	pagination: { paginationModel: DEFAULT_PAGINATION_MODEL },
};
